import { config } from '@/forms/config';
import type {
  FormConditionalValidation,
  FormField,
  FormInitialValues,
  FormValidations,
} from '@/forms/typings';
import type { LoginFormField } from '@/forms/typings';

import type { FormFieldModuleContext } from '../registry/field-module.types';

export function buildLoginInitialState(
  field: FormField,
  values: FormInitialValues,
  validations: FormValidations,
  conditions: FormConditionalValidation[] | undefined,
  ctx: FormFieldModuleContext,
): { initialValues: FormInitialValues; validationFields: FormValidations } {
  let initialValues: FormInitialValues = { ...values };
  let validationFields: FormValidations = { ...validations };

  const f = field as LoginFormField;

  initialValues[`${f.field.fieldId}${config.loginFieldQuestionTypeSuffix}`] =
    f.questionType;

  const detailValuesAndValidations = ctx.recurse(
    f.field,
    initialValues,
    validationFields,
    conditions,
  );

  initialValues = {
    ...initialValues,
    ...detailValuesAndValidations.initialValues,
  };
  validationFields = {
    ...validationFields,
    ...detailValuesAndValidations.validationFields,
  };

  return { initialValues, validationFields };
}
